import {environment} from '../../../environments/environment';
import {UserHelper} from '../../utils/UserHelper';
import {Injectable} from '@angular/core';
import {Http, RequestOptions, Headers, Response} from '@angular/http';
import {Observable} from 'rxjs/Observable';

@Injectable()
export class CloudFunctionHttpClient {
  constructor(private userHelper: UserHelper, private http: Http) {
  }

  public async asyncGet(requestUrl): Promise<any> {
    const options = await this.getOptions();
    const url = this.getUrl(requestUrl);

    const data = this.http.get(url, options).map(res => res.json());
    return await this.subscribeWrapper(data);
  }

  public async asyncPost(requestUrl, body, parseResult?: boolean): Promise<Response> {
    const options = await this.getOptions();
    const url = this.getUrl(requestUrl);

    let data = this.http.post(url, body, options);
    if (parseResult) {
      data = data.map(res => res.json());
    }
    return await this.subscribeWrapper(data);
  }

  private subscribeWrapper(dataProvider: Observable<Response>): Promise<Response> {
    return new Promise((resolve, reject) => {
      const subscriber = dataProvider.subscribe(
        data => {
          subscriber.unsubscribe();
          resolve(data);
        },
        err => {
          subscriber.unsubscribe();
          resolve(err);
        }
      );
    });
  }

  private getUrl(requestUrl) {
    return `${environment.httpFunctionsHost}/${requestUrl}`;
  }

  private async getOptions(): Promise<RequestOptions> {
    const token = await this.userHelper.getUserToken();
    const headers = new Headers(
      {
        'Authorization': `Bearer ${token}`,
        'Access-Control-Allow-Origin': '*'
      });
    const options = new RequestOptions({headers: headers});
    return options;
  }
}



// WEBPACK FOOTER //
// C:/xampp/htdocs/roche/roche/src/app/base/service/CloudFunctionHttpClient.ts